import type { ReactNode } from "react";
import { Box } from "@mui/material";
import type { AuthlessPrintRowState } from "./use-authless-print-row";

export type AuthlessPrintChromeProps<T> = AuthlessPrintRowState<T> & {
  children: (data: T) => ReactNode;
};

/**
 * Shared loading / “No Results Found” chrome for authless print routes
 * (CommonReceiptA5 and receipt-layout holdouts).
 */
function AuthlessPrintChrome<T>({ data, error, children }: AuthlessPrintChromeProps<T>) {
  if (error) {
    return <Box p={3}>No Results Found</Box>;
  }

  if (!data) {
    return <Box p={3}>...Loading</Box>;
  }

  return <>{children(data)}</>;
}

export default AuthlessPrintChrome;
